import { forwarded } from '@snsw-gel/utils'
import React, { CSSProperties, ReactNode, Ref } from 'react'
import { ColStyled, colSpanVar } from './Col.styled'

export interface ColProps {
    span: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12
    children?: ReactNode
    className?: string
    style?: CSSProperties
}

export const Col = forwarded((props: ColProps, ref: Ref<HTMLDivElement>) => {
    return (
        <ColStyled
            {...props}
            ref={ref}
            style={{
                ...(props.style || {}),
                ...colSpanVar.setStyle(String(props.span)),
            }}
        >
            {props.children}
        </ColStyled>
    )
})
